
import React from 'react';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

const Trek = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Grid container spacing={4} direction={isMd ? 'row' : 'column-reverse'}>
      <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          xs={12}
          md={6}
          sx={{
            display: { xs: 'none', md: 'flex' },
          }}
        >
          <Box component={Card} boxShadow={4} height={1} width={1}>
            <Box
              component={CardMedia}
              height={1}
              width={1}
              minHeight={300}
              image="https://scontent.fblr22-1.fna.fbcdn.net/v/t1.6435-9/38692670_1885830604788308_8712571000815878144_n.jpg?_nc_cat=104&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=Q8sJducU1HQAX9SZ11N&_nc_ht=scontent.fblr22-1.fna&oh=00_AT8ba0UBlxvJgxyc7V0ALHjpWpIyN4Jd69lDvghIubfFpg&oe=62FE783D"
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} data-aos={isMd ? 'fade-right' : 'fade-up'}>
          <Box marginBottom={4}>
          <Box marginTop={{ xs: 2, sm: 4 }}>
              <Typography variant={'h4'} sx={{ fontWeight: 700 }}
              align={'justify'}>
               I-5 ACADEMY
              </Typography>
              <Typography color="text.secondary" align={'justify'}></Typography>
            </Box>
            <Typography variant={'h6'} component={'p'} align={'justify'}>
            The Montessori wing at National Public School, Yeshwanthpur is called /
named as I-5 ACADEMY Bangalore.
<br></br>
<br></br>
We foster learning by providing innovative, educational and experiential
programmes, towards the development of dynamic individuals with strongmoral values and a passion for lifelong learning..
            </Typography>
 
          </Box>
        </Grid>
       
      </Grid>
    </Box>
  );
};

export default Trek;
